module.exports = __webpack_public_path__ + "img/p74.86522740.png";